<template>
	<section
		id="fullMap"
		class="bg-white relative z-10 will-change"
		:data-scroll-section="inner == 'false'"
		ref="masterMap"
	>
		<div class="mb-12 pt-10 xl:pt-[120px]" v-if="blockData.title">
			<h2
				class="text-4xl xl:text-heading text-center tracking-[2px] leading-none px-8 mb-7 w-full"
				v-html="blockData.title"
			></h2>
		</div>

		<div class="h-[67vh] relative" :class="{ 'mx-content': !isEvent }">
			<div
				ref="sidebar"
				class="sidebar bg-white bg-opacity-90 rounded md:w-[284px] absolute left-4 top-4 z-20 scroll-just-this max-h-[calc(100%-36px)] overflow-auto"
			>
				<button
					class="flex items-center rounded p-6 cursor-pointer w-full"
					type="button"
					@click="legendShow = !legendShow"
				>
					<img
						:src="
							this.endpoints.template_url + '/assets/img/masterplan-legend.png'
						"
						:alt="'masterplan-legend-icon'"
					/>
					<div class="text-navy-blue-01 ml-4 mr-auto">
						{{ __("Map Legend", "ccave") }}
					</div>
					<svg
						v-if="!legendShow"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13 6L8 11L3 6"
							stroke="#001E31"
							stroke-width="1.2"
							stroke-linecap="square"
						/>
					</svg>

					<svg
						v-if="legendShow"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M3 11L8 6L13 11"
							stroke="#001E31"
							stroke-width="1.2"
							stroke-linecap="square"
						/>
					</svg>
				</button>

				<div :class="{ 'block active': legendShow, hidden: !legendShow }">
					<hr class="border-light-grey" />
					<div v-for="(type, index) in poiTypes" :key="index">
						<div class="form-control form-control--map flex items-center p-6">
							<img :src="type.fields.icon.url" :alt="type.fields.icon.alt" />
							<label class="ml-4 w-full" :for="type.name">
								<!-- <input
									type="checkbox"
									:id="type.name"
									:value="type.term_id"
									v-model="checkedPOIs"
									@change="check($event)"
								/> -->
								<span class="text-navy-blue-01 text-sm">{{ type.name }}</span>
							</label>
						</div>
						<hr class="border-light-grey" />
					</div>

					<!-- <div class="text-xs p-6">{{ __('Click the checkmarks to switch visibility', 'ccave') }}</div> -->
				</div>
			</div>

			<div
				id="map-style"
				class="flex items-center absolute right-0 bottom-24 xl:right-8 xl:bottom-10 z-10"
			>
				<img
					class="border-transaprent border-2 rounded-lg cursor-pointer mx-2 w-9 h-9 xl:w-auto xl:h-auto"
					:class="{ 'border-white': activeStyle === styles[0].id }"
					:src="this.endpoints.template_url + '/assets/img/satellite-view.png'"
					:alt="'satellite-view-img'"
					@click="changeMapStyle(styles[0].id)"
				/>
				<img
					class="border-transaprent border-2 rounded-lg cursor-pointer mx-2 w-9 h-9 xl:w-auto xl:h-auto"
					:class="{ 'border-white': activeStyle === styles[1].id }"
					:src="this.endpoints.template_url + '/assets/img/street-view.png'"
					:alt="'street-view-img'"
					@click="changeMapStyle(styles[1].id)"
				/>
			</div>

			<!-- map -->
			<div id="map" class="rounded-lg" style="height: 100%"></div>
			<!-- map -->
		</div>

		<div
			class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap"
		>
			<span>{{
				__("Click on the interest point or zoom in to view more", "ccave")
			}}</span>
		</div>

		<div
			:class="{
				'xyz-in z-[51] active-card': showSlide,
				'xyz-out z-[40]': !showSlide,
			}"
			class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] invisible overflow-y-auto overflow-auto scroll-just-this"
			xyz="fade right-100% duration-4"
			ref="slideCard"
			data-scroll
			data-scroll-sticky
			data-scroll-target="#fullMap"
			v-on-clickaway="clickAwaySlide"
		>
			<button
				type="button"
				@click="
					showSlide = false;
					$refs.slideCard.style.visibility = 'invisible';
				"
				class="grid place-items-center bg-light-grey rounded-full cursor-pointer hover:opacity-70 w-[44px] h-[44px] absolute right-4 top-4"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="h-6 w-6"
					fill="none"
					viewBox="0 0 24 24"
					stroke="white"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>
			<div v-if="activePoint">
				<img
					class="object-cover w-full"
					:src="activePoint.poi[0].fields.image.sizes.customslide"
					:alt="activePoint.poi[0].fields.image.alt"
				/>

				<div class="p-8">
					<h4 class="text-2xl tracking-[1px] mb-6">
						{{ activePoint.poi[0].post_title }}
					</h4>
					<div class="text-sm" v-html="activePoint.poi[0].fields.text"></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import mapboxgl from "mapbox-gl";
import centerOfMass from "@turf/center-of-mass";
import { mixin as clickaway } from "vue-clickaway";
export default {
	name: "MasterplanMap",
	mixins: [clickaway],
	data() {
		return {
			isEvent: false,
			activePoint: false,
			showSlide: false,
			poiTypes: false,
			checkedPOIs: [],
			map: false,
			layerId_poiTypeId_Pair: new Map(),
			styles: [
				{ id: "mapbox://styles/aleksandarstojsin/ckxreflet1y4v14pptbu6meh1" },
				{ id: "mapbox://styles/aleksandarstojsin/ckxrfc6x570hh14pejpm0wfa5" },
			],
			activeStyle: false,
			legendShow: false,

			clusterData: false,
			datalayerAdded: false,
			poiTypesAdded: false,
		};
	},
	mounted() {
		if (
			this.$refs.masterMap.parentElement.classList.contains(
				"single-event__news-content"
			)
		)
			this.isEvent = true;

		mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map", // container ID
			/* style: this.blockData.map.map_settings.style, */ // style URL
			style:
				this.blockData.map_style == "Satellite"
					? "mapbox://styles/aleksandarstojsin/ckxreflet1y4v14pptbu6meh1"
					: "mapbox://styles/aleksandarstojsin/ckxrfc6x570hh14pejpm0wfa5",
			center: this.blockData.map.map_settings.center, // starting position
			zoom: this.blockData.map.map_settings.zoom, // starting zoom
			pitch: this.blockData.map.map_settings.pitch,
			bearing: this.blockData.map.map_settings.bearing,
			cooperativeGestures: true,
			attributionControl: false,
		});

		this.map.addControl(new mapboxgl.NavigationControl());
		this.map.scrollZoom.disable();

		(this.activeStyle =
			this.blockData.map_style == "Satellite"
				? "mapbox://styles/aleksandarstojsin/ckxreflet1y4v14pptbu6meh1"
				: "mapbox://styles/aleksandarstojsin/ckxrfc6x570hh14pejpm0wfa5"),
			this.map.on("style.load", () => {
				if (this.activeStyle) {
					this.getPOITypes();
					this.addDataLayer();
				}
			});

		this.map.on("load", () => {
			this.getPOITypes();
			this.addDataLayer();
		});

		this.$refs.sidebar.addEventListener("mouseenter", (e) => {
			this.$root.scroll.stop();
		});
		this.$refs.sidebar.addEventListener("mouseleave", (e) => {
			this.$root.scroll.start();
		});
	},
	watch: {
		showSlide: function (val) {
			if (val) {
				this.$root.scroll.stop();
			} else {
				this.$root.scroll.start();
			}
		},
	},
	methods: {
		clickAwaySlide() {
			this.showSlide = false;
		},
		addDataLayer() {
			if (this.datalayerAdded) {
				return;
			}

			this.clusterData = {
				type: "ClusterData",
				crs: {},
				features: [],
			};

			this.blockData.map.markers.forEach((marker, index) => {
				let mapData = JSON.parse(marker.map_data);
				if (mapData.geometry.type === "Polygon") {
					this.map.addSource("polygon" + index, {
						type: "geojson",
						data: mapData,
					});

					this.map.addLayer({
						id: "fill" + index,
						type: "fill",
						source: "polygon" + index,
						layout: {},
						paint: {
							"fill-color": "#0080ff", // mora boja i opacity na nula da bi bilo transparentno, amozda moze i drugacije
							"fill-opacity": 0,
						},
					});

					this.map.addLayer({
						id: "outline" + index,
						type: "line",
						source: "polygon" + index,
						layout: {},
						paint: {
							"line-color": "#FFF",
							"line-width": 0,
						},
					});
					var comPt = centerOfMass(mapData);

					this.map.addSource("label" + index, {
						type: "geojson",
						data: comPt,
					});

					this.map.addLayer({
						id: "label-style" + index,
						type: "symbol",
						source: "label" + index,
						layout: {
							"text-field": marker.name,
							"text-font": [
								"Canela Regular",
								"Open Sans Semibold",
								"Arial Unicode MS Bold",
							],
							"icon-allow-overlap": true,
							"text-allow-overlap": true,
						},
						paint: {
							"text-color":
								!this.activeStyle || this.activeStyle === this.styles[0].id
									? "white"
									: "black",
						},
					});
				} else {
					mapData.properties = marker;
					this.clusterData.features.push(mapData);
				}
			});

			// Cluster data
			this.map.addSource("pois", {
				type: "geojson",
				data: this.clusterData,
				cluster: true,
				maxzoom: 20,
				clusterMaxZoom: 30,
				clusterRadius: 40,
				/* tolerance: 0 */
			});

			this.map.addLayer({
				id: "clusters",
				type: "circle",
				source: "pois",
				filter: ["has", "point_count"],
				paint: {
					"circle-color": [
						"step",
						["get", "point_count"],
						"#FFFFFF",
						100,
						"#FFFFFF",
						750,
						"#FFFFFF",
					],
					"circle-radius": [
						"step",
						["get", "point_count"],
						20,
						100,
						30,
						750,
						40,
					],
				},
			});

			this.map.addLayer({
				id: "cluster-count",
				type: "symbol",
				source: "pois",
				filter: ["has", "point_count"],
				layout: {
					"text-field": "{point_count_abbreviated}",
					"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
					"text-size": 12,
					"text-allow-overlap": true,
				},
			});

			this.map.addLayer({
				id: "unclustered-point",
				type: "symbol",
				source: "pois",
				filter: ["!", ["has", "point_count"]],
				layout: {
					"icon-image": [
						"get",
						"term_id",
						["at", 0, ["get", "poi_types", ["at", 0, ["get", "poi"]]]],
					],
					"icon-anchor": "bottom",
					"icon-allow-overlap": true,
					"text-field": ["get", "post_title", ["at", 0, ["get", "poi"]]],
					"text-allow-overlap": true,
					"text-size": 14,
					"text-offset": [0, 1],
				},
				paint: {
					"text-color": "#ffffff",
					"text-halo-width": 1,
					"text-halo-blur": 0,
					"text-halo-color": "rgba(0, 0, 0, 0.6)",
				},
			});

			this.map.on("click", "clusters", (e) => {
				const features = this.map.queryRenderedFeatures(e.point, {
					layers: ["clusters"],
				});
				const clusterId = features[0].properties.cluster_id;
				this.map
					.getSource("pois")
					.getClusterExpansionZoom(clusterId, (err, zoom) => {
						if (err) return;
						this.map.flyTo({
							center: features[0].geometry.coordinates,
							zoom: zoom,
							animate: true,
							essential: true,
						});
					});
			});

			this.map.on("click", "unclustered-point", (e) => {
				e.originalEvent.preventDefault();
				e.originalEvent.stopPropagation();
				const coordinates = e.features[0].geometry.coordinates.slice();
				e.features[0].properties.poi = JSON.parse(e.features[0].properties.poi);

				if (
					this.$refs.slideCard.classList.contains("invisible") &&
					!this.showSlide &&
					e.features[0].properties.poi[0].fields.image &&
					e.features[0].properties.poi[0].fields.text
				) {
					this.activePoint = e.features[0].properties;
					this.$refs.slideCard.style.visibility = "visible";
					this.showSlide = true;
				} else {
					this.showSlide = false;
				}

				while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
					coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
				}

				this.map.flyTo({
					center: coordinates,
					/* offset: [0, -100], */
					zoom: 17,
					bearing: 0,
					speed: 1.5,
					curve: 1,
					easing: (x) => x * x * x,
					essential: true,
				});
			});

			this.map.on("mouseenter", "clusters", () => {
				this.map.getCanvas().style.cursor = "pointer";
			});
			this.map.on("mouseleave", "clusters", () => {
				this.map.getCanvas().style.cursor = "";
			});
			this.map.on("mouseenter", "unclustered-point", () => {
				this.map.getCanvas().style.cursor = "pointer";
			});
			this.map.on("mouseleave", "unclustered-point", () => {
				this.map.getCanvas().style.cursor = "";
			});

			this.datalayerAdded = true;
		},
		getPOITypes() {
			if (this.poiTypesAdded) {
				return;
			}

			let allPoiTypes = [];
			this.blockData.map.markers.forEach((marker) => {
				allPoiTypes.push(marker.poi[0].poi_types[0]);
			});
			this.poiTypes = allPoiTypes.filter(
				(value, index, self) =>
					index === self.findIndex((t) => t.term_id === value.term_id)
			);
			this.poiTypes.forEach((type) => this.checkedPOIs.push(type.term_id));

			this.poiTypes.forEach((type) => {
				this.map.loadImage(type.fields.marker.url, (error, image) => {
					if (error) throw error;
					this.map.addImage(type.term_id, image);
				});
			});

			this.poiTypesAdded = true;
		},
		check(e) {},
		changeMapStyle(style) {
			this.activeStyle = style;
			this.map.setStyle(this.activeStyle);
			this.poiTypesAdded = false;
			this.datalayerAdded = false;
		},
	},
};
</script>

<style scoped>
#fullMap {
	opacity: 1 !important;
	pointer-events: all !important;
	transform: none !important;
}
.map {
	position: absolute;
	left: 33.3333%;
	width: 66.6666%;
	top: 0;
	bottom: 0;
}
</style>
